import React from "react";

const StatusComponent = ({ value, item }: { value: string; item: any }) => {
  return (
    <div>
      <span
        className={
          value === "ongoing"
            ? "px-2 py-[2px] bg-[#F2E7BD] text-[#D07E10] rounded-full font-IRANSans font-normal text-xs"
            : "px-2 py-[2px] bg-[#E7F5E9] text-[#24AF22] rounded-full font-IRANSans font-normal text-xs"
        }
      >
        {value === "ongoing" ? "پرداخت ناقص" : "تسویه شده"}
      </span>
    </div>
  );
};

export default StatusComponent;
